import { render } from "./TimeoutFacturaDialog.vue?vue&type=template&id=482a9c60&scoped=true"
import script from "./TimeoutFacturaDialog.vue?vue&type=script&lang=js"
export * from "./TimeoutFacturaDialog.vue?vue&type=script&lang=js"

import "./TimeoutFacturaDialog.vue?vue&type=style&index=0&id=482a9c60&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482a9c60"]])

export default __exports__